import Vue from 'vue'


import CommonTable from '../components/widget/CommonTable'
import Search from '../components/widget/Search'
import RichTextField from '../components/widget/RichTextField'
import ImageUpload from '../components/widget/ImageUpload'
import DrawerForm from "../components/widget/DrawerForm";
import VideoUpload from "../components/widget/VideoUpload";

import MenuTree from "../components/widget/MenuTree";
Vue.component("MenuTree",MenuTree)
Vue.component("DrawerForm",DrawerForm)
Vue.component("Search",Search)
Vue.component("LSearch",Search)
Vue.component("CommonTable",CommonTable)
Vue.component("RichTextField",RichTextField)
Vue.component("ImageUpload",ImageUpload)
Vue.component("VideoUpload",VideoUpload)
import MultiImageUpload from "../components/widget/MultiImageUpload"
Vue.component("MultiImageUpload",MultiImageUpload)

import PageContent from "../components/common/PageContent";
Vue.component("PageContent",PageContent)

import CommonForm from "../components/widget/CommonForm";
Vue.component("CommonForm",CommonForm)

import IconSelect from "../components/widget/IconSelect";
Vue.component("IconSelect",IconSelect)

import CsvImport from "../components/widget/CsvImport";
Vue.component("CsvImport",CsvImport)

import ColorPicker from "../components/widget/ColorPicker";
Vue.component("ColorPicker",ColorPicker)

import LocationPicker from "../components/widget/LocationPicker";
Vue.component("LocationPicker",LocationPicker)

import PasswordInput from "../components/widget/PasswordInput";
Vue.component("PasswordInput",PasswordInput)



// WEBPACK FOOTER //
// ./src/_dependency/my-components.js